export default __webpack_public_path__ + "static/media/viktor.5a3ed8e3.png";